import React, { Component } from "react"
import styled from "styled-components"
import { Link, navigate } from "gatsby"
import { constants } from "../../constants/constants"
import { colors } from "../../style/colors"

const Container = styled.div`
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: ${constants.navWidth}; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 100; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  background-color: white;
  overflow-x: hidden; /* Disable horizontal scroll */
  padding: 20px 10px 0 25px;
  border-right: 1px solid #f1f1f1;
`
const Logo = styled.img`
  width: 140px;
  margin-bottom: 2rem;
  cursor: pointer;
`
const Submenu = styled.ul`
  list-style: none;
  margin: 0;
  display: ${props => (props.visible ? "block" : "none")};
`
const Menu = styled.nav`
  list-style: none;
  margin: 0;
  margin-top: 30px;
`
const Item = styled.li`
  margin: 0;
  margin-bottom: 13px;
  font-family: "Akkurat";
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
`
const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
const Icon = styled.h5`
  margin: 0;
  font-size: 14px;
  color: black;
`
const Name = styled.h5`
  margin: 0;
  text-transform: uppercase;
  font-size: 14px;
  color: black;
`
const SubName = styled.h5`
  margin: 0;
  font-size: 13px;
  text-transform: none;
  margin-top: 6px;
  margin-left: 10px;
  color: #515151;
  transition: 0.2s ease;
  line-height: 17px;
  :hover {
    color: ${colors.main};
  }
`

class Navbar extends Component {
  state = {
    projects: [],
    activeCategory: "",
  }

  componentDidMount() {
    this.createMenu()
  }

  handleSelectCategory = category => {
    const { activeCategory } = this.state

    if (activeCategory === category) {
      //Collapse the menu by removing the active category
      this.setState({ activeCategory: null })
      return
    }

    this.setState({ activeCategory: category })
  }

  createMenu = () => {
    let projects = this.props.projects.map(project => {
      //Check to see if/whether a menu item is active
      //TODO: CHeck for unnecessary renders
      if (
        this.state.activeCategory === "" &&
        project.node.categories[0].slug === this.props.activeSlug
      ) {
        this.setState({ activeCategory: project.node.categories[0].name })
      }

      return {
        title: project.node.title,
        slug: project.node.slug,
        category: project.node.categories[0].name,
        categorySlug: project.node.categories[0].slug,
      }
    })

    this.setState({ projects })
  }

  renderSubMenu = category => {
    const { projects } = this.state
    let items = projects.filter(proj => proj.category === category)
    var menu = []
    items.map((item, index) =>
      menu.push(
        <ListItem key={index}>
          <SubName>
            <Link
              activeStyle={{ color: colors.main }}
              style={{ color: "inherit", textDecoration: "none" }}
              to={`/projects/${item.categorySlug}/${item.slug}`}
              state={{ category: item.category }}
            >
              {item.title}
            </Link>
          </SubName>
        </ListItem>
      )
    )

    return menu
  }

  render() {
    const { activeCategory } = this.state
    return (
      <Container>
        <Link to="/">
          <Logo
            alt="logo"
            src={require("../../images/logo.png")}
          />
        </Link>
        <Menu>
          {this.props.categories.filter(el => el.node.name !== "Uncategorized").map((category, index) => (
            <Item
              onClick={() => this.handleSelectCategory(category.node.name)}
              key={index}
            >
              <ListItem>
                <Icon>{activeCategory === category.node.name ? "−" : "+"}</Icon>
                <Name>{category.node.name}</Name>
              </ListItem>
              <Submenu visible={activeCategory === category.node.name}>
                {this.renderSubMenu(category.node.name)}
              </Submenu>
            </Item>
          ))}
        </Menu>
      </Container>
    )
  }
}

export default Navbar